import * as types from "./actionTypes";
import * as exception from "./exceptionActions";

export function loadSettings() {
	return function (dispatch) {
		const settings = {};

		if (!window.settings) {
			dispatch(exception.throwException("No valid settings from api"));
			return;
		}

		settings.portalRoot = window.settings.portalRoot;
		settings.dagenNodigVoorMachtiging = window.settings.dagenNodigVoorMachtiging;
		settings.helpdeskContactLink = window.settings.helpdeskContactLink;
		settings.eloketUrl = window.settings.eloketUrl;
		settings.fileTypes = window.settings.fileTypes;
		settings.maxAllowedContentLength = window.settings.maxAllowedContentLength;
		settings.sportDBUrl = window.settings.sportDBUrl;
		settings.maxMapFeaturesToLoad = window.settings.MaxMapFeaturesToLoad;
		settings.osmBaseLayerUrl = window.settings.OSMBaseLayerUrl;
		settings.bevoorradingMarkerName = window.settings.BevoorradingMarkerName;
		settings.bepijlingMarkerName = window.settings.BepijlingMarkerName;
		settings.apiRoot = "/veldtoertochten.webapi/api";
		settings.siteRoot = "/veldtoertochten.portal";

		dispatch(readSettingsSuccess(settings));
	};
}

export function getSettings() {
	return (dispatch, getState) => {
		const state = getState();
		return state;
	};
}

export function disablePage(disablePage) {
	return function (dispatch) {
		dispatch(disablePageSet(disablePage));
	};
}

export function readSettingsSuccess(settings) {
	return {
		type: types.READ_SETTINGS_SUCCESS,
		data: settings
	};
}

export function disablePageSet(disablePage) {
	return {
		type: types.DISABLE_PAGE,
		disablePage: disablePage
	};
}

